import { SourceOfResourceEntity } from '../entities/source-of-resource-entity';

export default class State {
  items: Array<SourceOfResourceEntity> = [];
}
